import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { QuidState } from './quid.types';
import { serializeRestaurant } from '../restaurant/restaurant.service';
import { serializeMenu } from '../menu/menu.service';

const initialState: QuidState = {
  restaurant: null,
  menus: [],
};

const quidSlice = createSlice({
  name: 'quid',
  initialState,
  reducers: {
    validateQuidSuccess: (state, action: PayloadAction<{menus: any, restaurant: any}>) => {
      state.restaurant = action.payload.restaurant;
      state.menus = (action.payload.menus ?? []).map(serializeMenu);
    },
    resetQuid: () => initialState,
  }
});

export const {
  validateQuidSuccess,
  resetQuid,
} = quidSlice.actions;

export default quidSlice.reducer;
